/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'history': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29.205 20.258l-3.268 3.27c.038.153.063.314.063.478a2.005 2.005 0 0 1-2 2.006c-.748 0-1.393-.512-1.736-1.012H19.5c-.275 0-.5-.249-.5-.523v-.953c0-.275.225-.524.5-.524h2.764c.344-.5.988-1.012 1.736-1.012.197 0 .385.049.565.102l3.238-3.237a.502.502 0 0 1 .707 0l.694.696a.502.502 0 0 1 .001.709zM35.791 26c.115-1 .197-1.334.197-2.018 0-6.618-5.383-12.01-12-12.01S11.994 17.35 11.994 23.969C11.994 30.584 17 35.963 24 35.963v-.002c2-.006 4.509-.642 6.527-1.961l.057-.039 1.476 2.046c.162.224.361.188.442-.073l2.205-6.44c.082-.263-.077-.48-.353-.486l-6.834.002c-.276-.006-.37.174-.21.396l1.515 2.12c-1.495.96-2.825 1.423-4.825 1.43v.008a8.986 8.986 0 0 1-9.006-9.001c0-4.971 4.027-9 8.998-9 4.97 0 8.998 4.048 8.998 9.02 0 .688-.092 1.018-.24 2.018h3.041z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/history.js